
import type { BlockRendererProps } from '@/lib/email-builder/block-registry';
import { parseBlockConfiguration } from '@/types/email-blocks';
import type { SpacerBlockConfiguration } from '@/types/block-configurations';

export function SpacerBlock({ block, isSelected, isHovered, onSelect, onHover }: BlockRendererProps) {
  const config = parseBlockConfiguration(block) as SpacerBlockConfiguration;

  return (
    <div
      onClick={(e) => {
        e.stopPropagation();
        onSelect(block.id);
      }}
      onMouseEnter={(e) => {
        e.stopPropagation();
        onHover(block.id);
      }}
      onMouseLeave={() => onHover(null)}
      className={`
        lw-block-spacer cursor-pointer rounded transition-all
        ${isSelected ? 'ring-2 ring-primary ring-offset-2' : ''}
        ${isHovered && !isSelected ? 'ring-1 ring-muted-foreground/50' : ''}
      `}
      style={{
        height: `${config.height ?? 20}px`,
        backgroundColor:
          isSelected || isHovered
            ? 'rgba(0, 0, 0, 0.05)'
            : config.backgroundColor || 'transparent',
      }}
    >
      {(isSelected || isHovered) && (
        <div className="flex items-center justify-center h-full text-xs text-muted-foreground">
          Spacer ({config.height ?? 20}px)
        </div>
      )}
    </div>
  );
}
